<!-- Band -->
<span class="display-band" kendoTooltip tooltipClass="kg-tooltip-style">
    <i
        class="fas"
        [ngClass]="{
            'fa-diamond band-very-high': PTFLabel == 'very high',
            'fa-square band-high': PTFLabel == 'high',
            'fa-circle band-medium': PTFLabel == 'medium',
            'fa-octagon band-low': PTFLabel == 'low',
            'fa-triangle band-very-low': PTFLabel == 'very low'
        }"
        [title]="PTFDesc"
    >
    </i>
</span>

<!-- Description -->
<p *ngIf="showDesc" id="text-band" class="display-band">
    <span class="band-very-high" *ngIf="PTFLabel == 'very high'">VERY HIGH</span>
    <span class="band-high" *ngIf="PTFLabel == 'high'">HIGH</span>
    <span class="band-medium" *ngIf="PTFLabel == 'medium'">MEDIUM</span>
    <span class="band-low" *ngIf="PTFLabel == 'low'">LOW</span>
    <span class="band-very-low" *ngIf="PTFLabel == 'very low'">VERY LOW</span>
</p>
